import { connect } from 'react-redux'
import Flow from './Flow'
import { submit } from 'redux-form'
import { saveFlow, publishFlow, confirmDeleteFlow } from '../Flows.actions'

const stateToProps = ({ flows: { savePending, publishPending } }) => ({
  savePending,
  publishPending,
})

const dispatchToProps = {
  saveFlow,
  publishFlow,
  confirmDeleteFlow,
  submit,
}

export default connect(stateToProps, dispatchToProps)(Flow)



// WEBPACK FOOTER //
// ./src/features/Flows/Flow/Flow.container.js